import { Component, OnInit } from "@angular/core";
import { ModalService } from "@core-services/modal.service";
import { TradeBuyComponent } from "@modules/trade/modals/trade-buy-modal/trade-buy-modal.component";
import { ActivatedRoute } from "@angular/router";
import { TradableOfferService } from "@modules/trade/services/tradable-offer-service";
import { TRADE_TYPE } from "@models/trade-offer.model";
import { LaunchDarklyService, LD_FLAG } from "@core-services/launch-darkly/launch-darkly.service";
import { CheckoutEntryHelperService } from "@modules/checkout/services/checkout-entry-helper.service";
import { take } from "rxjs/operators";

@Component({
	selector: "trade-buy-dialog",
	template: "",
	standalone: false
})
export class TradeBuyDialogComponent implements OnInit {
	constructor(
		private modalService: ModalService,
		private tradableOfferService: TradableOfferService,
		private route: ActivatedRoute,
		private launchDarklyService: LaunchDarklyService,
		private checkoutEntryHelper: CheckoutEntryHelperService
	) {}

	public ngOnInit(): void {
		this.launchDarklyService
			.isActive$(LD_FLAG.CHECKOUT_FLOW_ENABLED)
			.pipe(take(1))
			.subscribe((checkoutEnabled) => {
				const snapshotMap = this.route.snapshot.queryParamMap;
				// Let limit order resolver take over
				if (
					snapshotMap.has("t") &&
					(snapshotMap.get("t") === "limit_order" || snapshotMap.get("t") === "margin_order")
				) {
					return;
				}
				// Buy dialog logic
				this.route.params.forEach(({ tradableId = "" }) => {
					if (checkoutEnabled) {
						this.checkoutEntryHelper.openCheckoutBuy(tradableId);
					} else {
						const { offer, tradable } = this.tradableOfferService.generateTradableOffer(tradableId);
						offer.setType(TRADE_TYPE.BUY);

						if (tradable && !tradable.isBuyActive()) {
							offer.setDirectTradableWalletOffer(false);
							offer.setWalletId("");
						}
						this.modalService.create(TradeBuyComponent, { data: offer }).present();
					}
				});
			});
	}
}
